import React, { Component } from 'react';
import { Modal, Button, Form, Checkbox } from 'semantic-ui-react';
import SaveButtonWithTooltip from '../SaveButtonWithTooltip';
import {
  //lengthGt,
  notEmpty,
  truthy,
  report,
  validUser
} from '../../../../common/utils/inputValidator.js';
import { updateInPath, logError } from '../../../../common/utils';
import Steps from './Steps.js';
import Tab from './Tab.js';
import { withNamespaces } from 'react-i18next';
import { Auth } from 'aws-amplify';
import { clone } from 'ramda';


const BLANK = {
  hasAcceptedCompetitionRules: false,
  event: {
    id: '',
    title: ''
  },
  competition: {
    id: '',
    title: ''
  },
  userData: {
    given_name: '',
    family_name: '',
    email: '',
    'custom:year_of_birth': '',
    'custom:occupation': '',
    'custom:occupation_details': '',
    'custom:country_of_residence': '',
    'custom:county_of_residence': ''
  }
};

class MutationModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      save: {
        enabled: true,
        errors: []
      },
      data: clone(props.data) || BLANK,
      activeTabIndex: 0
    };

    if (!props.data) {
      this.updateUserData();
    }
  }

  updateUserData = async () => {
    try {
      const user = await Auth.currentAuthenticatedUser();
      this.setState(s => updateInPath(s, 'data.userData', user.attributes));
    } catch (err) {
      logError(err);
    }
  };

  saveEnabled = (data) => {
    const checks = [
      notEmpty(data.competition.id, 'Competition'),
      truthy(data.hasAcceptedCompetitionRules, true, 'Must accept competition rules')
    ];

    return report(checks);
  };

  handleSave = () => {
    this.props.onSave(this.state.data);
  };

  handleDelete = async () => {
    const data = clone(this.state.data);
    this.props.onDelete(data.workshopId, data.userId);
  };

  handleTabChange = (e, {activeIndex}) => {
    this.setState(prevState => updateInPath(prevState, 'activeTabIndex', activeIndex));
  }

  handleChange = (e, {name, value}) => {
    this.setState(s => updateInPath(s, 'data.' + name, value));
  };

  handleToggle = (e, {name, checked}) => {
    this.setState(s => updateInPath(s, 'data.' + name, checked));
  };

  handleCompetitionUpdate = (e, { name, value }) => {
    this.setState(prevState => {
      const newState = clone(prevState);
      newState.data.competition.id = value;
      newState.data.competition.title = name;
      return newState;
    });
  };

  handleEventUpdate = (e, {name, value, options }) => {
    this.setState(prevState => {
      const newState = clone(prevState);
      newState.data.event.id = value;
      newState.data.event.title = name;
      newState.data.competition.id = '';
      return newState;
    });
  };

  handleUpdateUserData = (e, { name, value }) => {
    // updateInpath does not work with 'custom:blaaah' paths
    this.setState(prevState => {
      const newState = clone(prevState);
      newState.data.userData[name] = value;
      return newState;
    });
  };

  hasValidCompetitionData = (competition) => {
    const c = clone(competition) || {};
    return !!c.id;
  };

  hasValidUser = (user) => {
    return validUser(user);
  };

  hasAcceptedRules = (acceptedRules) => {
    return !!acceptedRules;
  }
  
  render() {
    // TODO this ...Ok part is not elegant
    const { t, open, events } = this.props,
          data = this.state.data,
          competition = data.competition,
          userOk = this.hasValidUser(data.userData),
          rulesOk = this.hasAcceptedRules(data.hasAcceptedCompetitionRules),
          extraOk = data.previousExperience && data.informationSource,
          competitionOk = this.hasValidCompetitionData(competition);


    return (
      <Modal open={open}>
        <Modal.Header content={t('private:addWorkshop.' + (data.workshopId ? 'edit' : 'add'))} />
        <Modal.Content>
          <Steps
            competitionOk={competitionOk}
            userOk={userOk}
            extraOk={extraOk}
            rulesOk={rulesOk}
            activeStep={this.state.activeTabIndex}
          />
          <Form>
            <Tab
              data={data}
              events={events}
              onEventUpdate={this.handleEventUpdate}
              onCompetitionUpdate={this.handleCompetitionUpdate}
              onParticipantDataUpdate={this.handleUpdateUserData}
              onChange={this.handleChange}
              onDelete={this.handleDelete}
              onTabChange={this.handleTabChange}
            />
          </Form>
        </Modal.Content>
        <Modal.Actions>
          { competition &&
            competition.id && <Checkbox
                                required
                                label={t('private:addWorkshop.acceptRules')}
                                name='hasAcceptedCompetitionRules'
                                checked={!!data.hasAcceptedCompetitionRules}
                                onChange={this.handleToggle} />}
          <Button
            content={t('common:cancel')}
            onClick={this.props.onClose}
          />
          <SaveButtonWithTooltip
            enabled={competitionOk && userOk && rulesOk && extraOk}
            tooltip={this.state.save.errors}
            onSave={this.handleSave}/>
        </Modal.Actions>
      </Modal>
    );
  };
};

export default withNamespaces(['private', 'common'])(MutationModal);



// WEBPACK FOOTER //
// ./src/private/common/components/Workshop/index.js